import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeadRegularPlusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.112 7.2a2.98 2.98 0 0 0 .506 2.62H4.766l2.384 4.79a3.11 3.11 0 0 1 0 2.774L4.766 22.18h19.262l3.514-6.181L24.7 11h2.301q.345-.002.668-.077l2.467 4.338a1.48 1.48 0 0 1 0 1.476l-4.066 7.15c-.317.56-.967.912-1.677.912H1.876a1 1 0 0 1-.267-.036l-.084-.028c-.442-.17-.645-.625-.452-1.014l3.733-7.502a.5.5 0 0 0 .039-.108L4.857 16a.5.5 0 0 0-.012-.113l-.04-.108-3.73-7.5L1 7.967c0-.424.394-.768.876-.769zM20.5 3c.468 0 .846.378.846.846v3.808h3.808a.845.845 0 1 1 0 1.692h-3.808v3.808a.845.845 0 1 1-1.692 0V9.346h-3.808a.845.845 0 1 1 0-1.692h3.808V3.846c0-.468.378-.846.846-.846" })
});
export default SvgLeadRegularPlusIcon;
